module.exports = __webpack_public_path__ + "9e4d9a9afb7623f17e42b3e0fefca9ed.svg";